import React from 'react';
import { Crown, Swords, Trophy } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';
import { MODE_COLORS, formatDate } from './constants';

const TournamentsTab = ({ tournamentResults }) => (
  <div className="glass-card rounded-xl overflow-hidden">
    <div className="p-4 border-b border-[#222] bg-[#FFD70010]">
      <h2 className="font-game text-sm text-[#FFD700]">TOURNAMENT RECORD ({tournamentResults.length})</h2>
    </div>
    <ScrollArea className="h-[450px]">
      {tournamentResults.map((t, i) => (
        <div key={i} className="flex items-center justify-between p-4 border-b border-[#1a1a1a] hover:bg-[#111]"
          data-testid={`tournament-result-${i}`}>
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${t.is_champion ? 'bg-[#FFD700]/20' : 'bg-[#333]'}`}>
              {t.is_champion ? <Crown className="w-5 h-5 text-[#FFD700]" /> : <Swords className="w-5 h-5 text-[#666]" />}
            </div>
            <div>
              <p className={`font-game text-sm ${t.is_champion ? 'text-[#FFD700]' : 'text-white'}`}>{t.name}</p>
              <div className="flex items-center gap-2 text-[10px] text-[#666]">
                <span>{t.bracket_size} players</span>
                <span style={{ color: MODE_COLORS[t.game_mode] }}>{t.game_mode}</span>
              </div>
            </div>
          </div>
          <div className="text-right">
            <p className={`font-game text-sm ${t.is_champion ? 'text-[#FFD700]' : t.eliminated ? 'text-[#FF3B30]' : 'text-white'}`}>
              {t.is_champion ? 'CHAMPION' : t.eliminated ? 'ELIMINATED' : 'PLAYED'}
            </p>
            <p className="text-xs text-[#A1A1AA]">Score: {t.best_score?.toLocaleString() || '-'}</p>
            <p className="text-[10px] text-[#666]">{formatDate(t.completed_at)}</p>
          </div>
        </div>
      ))}
      {tournamentResults.length === 0 && (
        <div className="p-8 text-center"><Trophy className="w-12 h-12 text-[#333] mx-auto mb-3" /><p className="text-[#666]">No tournaments yet</p></div>
      )}
    </ScrollArea>
  </div>
);

export default TournamentsTab;
